
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "Search"
})
export default class Search extends Vue {
  @Prop({ default: () => false }) public disabled!: boolean;
  @Prop({ default: () => false }) public always_active!: boolean;

  public search: string = this.$store.state.search;
  public show_input: boolean = false;

  protected created() {
    if (this.always_active) {
      this.show_input = true;
    }
  }

  protected onSearch() {
    this.$store.commit("search", this.search);
  }

  protected openSearch() {
    if (!this.disabled) {
      this.show_input = true;
    }
  }

  protected closeSearch() {
    this.show_input = false;
    this.search = "";

    this.$store.commit("search", "");
  }

  protected beforeDestroy() {
    this.show_input = false;

    this.$store.commit("search", "");
  }
}
